import { NavLink } from 'react-router-dom'
import {
  LayoutDashboard, Users, CreditCard,
  TrendingUp, Settings, Megaphone, ClipboardList, LogOut, Receipt, Flag, Globe, Star,
} from 'lucide-react'
import { cn } from '../../utils/cn'
import { useAdminStore } from '../store/adminStore'
import { adminSupabase } from '../lib/adminClient'

const nav = [
  { to: '/admin',                  label: 'Overview',      icon: LayoutDashboard },
  { to: '/admin/tenants',          label: 'Tenants',       icon: Users },
  { to: '/admin/subscriptions',    label: 'Subscriptions', icon: CreditCard },
  { to: '/admin/revenue',          label: 'Revenue',       icon: TrendingUp },
  { to: '/admin/expenses',         label: 'Expenses',      icon: Receipt },
  { to: '/admin/features',         label: 'Feature Flags', icon: Flag },
  { to: '/admin/custom-domains',   label: 'Custom Domains', icon: Globe },
  { to: '/admin/showcase',         label: 'Customer Showcase', icon: Star },
  { to: '/admin/settings',         label: 'Platform Settings', icon: Settings },
  { to: '/admin/announcements',    label: 'Announcements', icon: Megaphone },
  { to: '/admin/audit',            label: 'Audit Log',     icon: ClipboardList },
]

export function AdminSidebar() {
  const { admin, logout } = useAdminStore()

  const handleLogout = () => {
    void adminSupabase.auth.signOut()
    logout()
  }

  return (
    <aside className="w-64 bg-gray-900 min-h-screen flex flex-col">
      {/* Logo */}
      <div className="px-6 py-5 border-b border-gray-800">
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-lg bg-brand-500 flex items-center justify-center">
            <span className="text-white font-bold text-sm">P</span>
          </div>
          <div>
            <p className="text-white font-bold text-sm">Palstro</p>
            <p className="text-gray-400 text-xs">Admin Console</p>
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-3 py-4 space-y-0.5">
        {nav.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/admin'}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors',
                isActive
                  ? 'bg-brand-500 text-white'
                  : 'text-gray-400 hover:text-white hover:bg-gray-800',
              )
            }
          >
            <Icon className="h-4 w-4 flex-shrink-0" />
            {label}
          </NavLink>
        ))}
      </nav>

      {/* Admin user */}
      <div className="px-3 py-4 border-t border-gray-800">
        <div className="flex items-center gap-3 px-3 py-2 mb-1">
          <div className="h-8 w-8 rounded-full bg-brand-500/20 flex items-center justify-center">
            <span className="text-brand-400 font-bold text-sm">{admin?.name?.[0] ?? 'A'}</span>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-white text-sm font-medium truncate">{admin?.name}</p>
            <p className="text-gray-500 text-xs truncate">{admin?.role}</p>
          </div>
        </div>
        <button
          onClick={handleLogout}
          className="flex items-center gap-3 px-3 py-2 w-full rounded-lg text-sm text-gray-400 hover:text-white hover:bg-gray-800 transition-colors"
        >
          <LogOut className="h-4 w-4" />
          Sign out
        </button>
      </div>
    </aside>
  )
}
